import { Box } from '@mui/material';
import DOMPurify from 'dompurify';
import { ContentState, convertToRaw, EditorState } from 'draft-js';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';
import React, { useEffect, useRef } from 'react';
import { Editor } from 'react-draft-wysiwyg';
import 'react-draft-wysiwyg/dist/react-draft-wysiwyg.css';

/** MyMine Version1.5 追加
 * RichEditor Component
 */
const RichEditor = ({ editorValue, onChange, sx, isReloadValue, setIsReloadValue, validateLocalImageUpload }) => {
  const getEditorState = () => {
    if (editorValue) {
      let contentBlocks = htmlToDraft(editorValue).contentBlocks;
      //画像上部に不要な改行が入るので削除
      const atomicBlockIndices = contentBlocks.reduce((indices, block, index) => {
        if (block.getType() === 'atomic') {
          indices.push(index -1);
        }
        return indices;
      }, []);
      for (var index in atomicBlockIndices.reverse()) {
        contentBlocks.splice(atomicBlockIndices[index], 1);
      }
      return EditorState.createWithContent(ContentState.createFromBlockArray(contentBlocks));
    } else {
      return EditorState.createEmpty();
    }
  }

  const editorStateRef = useRef(getEditorState());

  useEffect(() => {
    if (isReloadValue) {
      editorStateRef.current = getEditorState();
      setIsReloadValue(false);
    }
  }, [isReloadValue]);

  const handleEditorChange = (state) => {
    editorStateRef.current = state;
    onChange(getInputSanitizeHtml(state));
  }

  /** サニタイズしたHTML文字列を取得 */
  const getInputSanitizeHtml = (state) => {
    /** Base64画像のブロックラッピング処理 */
    const customEntityTransform = (entity, text) => {
      const position = entity.data.hasOwnProperty('alignment') && (entity.data.alignment === 'left' || entity.data.alignment === 'right') ? entity.data.alignment : 'center';

      if (entity.type !== 'IMAGE') return;
      return `<div class='w-100' style='text-align:${position};overflow:hidden'><img src=${entity.data.src} style='float:${position};height:${entity.data.height};width:${entity.data.width}' alt='' /></div>`;
    };

    const raw = convertToRaw(state.getCurrentContent());

    let sanitizeHtml = DOMPurify.sanitize(draftToHtml(raw, {}, false, customEntityTransform).trim(), { ADD_ATTR: ['target'] });

    // HTMLがpタグのみの場合は空白と判断
    if (sanitizeHtml === '<p></p>') {
      sanitizeHtml = '';
    }
    // 値が無いpタグは改行タグに変換
    sanitizeHtml = sanitizeHtml.replace(/<p><\/p>/g, '</br>')
    sanitizeHtml = sanitizeHtml.replace(/\n/g, "\r\n");

    // 末尾に画像が配置されている場合はpタグに変換
    const divWithImgPattern = /<div[^>]*>\s*<img[^>]*>\s*<\/div>\s*<\/br>$/;
    const emptyBrTagPattern = /<\/br>$/;
    if (divWithImgPattern.test(sanitizeHtml)) {
      return sanitizeHtml.replace(emptyBrTagPattern, '<p></p>');
    } else {
      return sanitizeHtml
    }
  }

  return (
    <Box sx={{
      '*': { fontSize: 'unset' },
      '.public-DraftStyleDefault-block': { margin: '5px 0' },
      '.rdw-option-wrapper': { height: '30px'},
      ...sx
    }}>
      <Editor
        editorState={editorStateRef.current}
        onEditorStateChange={handleEditorChange}
        wrapperClassName='wrapper-class'
        editorClassName='editor-class'
        toolbarClassName='toolbar-class'
        toolbar={{
          options: ['inline', 'fontSize', 'list', 'link', 'image', 'remove'],
          inline: { inDropdown: true },
          fontSize: {
            options: [10, 11, 12, 14, 16, 18, 24, 30, 36],
          },
          list: { inDropdown: true, options: ['unordered', 'ordered'], },
          link: { inDropdown: true },
          textAlign: { inDropdown: true },
          image: {
            urlEnabled: false,
            uploadEnabled: true,
            uploadCallback: (file) => {
              return new Promise(
                (resolve, reject) => {
                  if (file) {
                    if (!validateLocalImageUpload || validateLocalImageUpload(file, convertToRaw(editorStateRef.current.getCurrentContent()))) {
                      let reader = new FileReader();
                      reader.onload = (e) => {
                        resolve({ data: { link: e.target.result } })
                      };
                      reader.readAsDataURL(file);
                    } else {
                      reject();
                    }
                  }
                }
              );
            },
            previewImage: true,
            alignmentEnabled: true,
            inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
            alt: { present: false, mandatory: false },
            defaultSize: {
              height: 'auto',
              width: 'auto',
            },
          },
        }}
        localization={{ locale: 'en', }}
      />
    </Box>
  )
}
export default RichEditor;